import React from 'react';
import PropTypes from 'prop-types';
import useSectionStyles from './sectionstyles';

const PrioritizationSection = ({
  contractId,
  contractSettingsData,
  boundActions,
  priorityStrategyState,
  priorityWorkByState
}) => {


  const classes = useSectionStyles();

  const handleWorkByChange = e => {
    const val = e.target.value;
    const contractSetting = Object.assign(contractSettingsData.priorityWorkBy, { value: val });
    boundActions.changeWorkByPriority(contractSetting, e);
  }

  const handleStrategyChange = e => {
    const val = e.target.value;
    const contractSetting = Object.assign(contractSettingsData.priorityStrategy, { value: val});
    boundActions.changeStrategyPriority(contractSetting, e);
  }

  const buildOption = (item, selectedValue) => {
    if (item.value == selectedValue) {
      return (<option key={item.value} value={item.value} selected>{item.label}</option>);
    }

    return (<option key={item.value} value={item.value}>{item.label}</option>);
  }

  const defaultWorkByValue = contractSettingsData.priorityWorkBy.value && contractSettingsData.priorityWorkBy.value >= 0 ? contractSettingsData.priorityWorkBy.value : 0;

  const defaultStrategyValue = contractSettingsData.priorityStrategy.value && contractSettingsData.priorityStrategy.value >= 0 ? contractSettingsData.priorityStrategy.value : 0;
  return (
    <div className={classes.priority}>
      <h5 style={{ marginTop: '0' }}><u>Prioritization Rules</u></h5>
      <div>
          <label>Work By</label>
          <select
            onChange={handleWorkByChange}
          >
          {
            priorityWorkByState.items.map(x => (
              buildOption(x, defaultWorkByValue)
            ))
          }
          </select>
        </div>
        <div>
          <label>Sort</label>
          <select
            onChange={handleStrategyChange}
          >
          {
            priorityStrategyState.items.map(x => (
              buildOption(x, defaultStrategyValue)
            ))
          }
          </select>
        </div>
    </div>
  );
};

PrioritizationSection.propTypes = {
  contractId: PropTypes.number.isRequired
};

export default PrioritizationSection;
